import ReactGA from 'react-ga4';
import { captureError } from './error-handling';
import { UserData } from './user-store';

export enum TrackedEvent {
  dpInitialPageLoad = 'dpInitialPageLoad',

  /* Page Header Section */
  pageHeaderBrandIconClicked = 'pageHeaderBrandIconClicked',
  pageHeaderCollapsedMenuToggle = 'pageHeaderCollapsedMenuToggle',
  pageHeaderMenuActionItemClicked = 'pageHeaderMenuActionItemClicked', // Property: title
  pageHeaderMenuLinkItemClicked = 'pageHeaderMenuLinkItemClicked', // Property: href

  /* Home Page Section */
  homePageCarouselItemClicked = 'homePageCarouselItemClicked', // Property: index
  homePageCarouselSwipe = 'homePageCarouselSwipe', // Property: direction
  homePageCarouselDotClicked = 'homePageCarouselDotClicked', // Property: index

  homePageLinksItemClicked = 'homePageLinksItemClicked', // Property: href

  /* API Access Section */
  apiAccessSelectedAppChanged = 'apiAccessSelectedAppChanged', // Property: value
  apiAccessGenerateAppTokensClicked = 'apiAccessGenerateAppTokensClicked', // Property: value
  apiAccessGenerateTokensClicked = 'apiAccessGenerateTokensClicked',
  apiAccessUsageExampleLanguageChanged = 'apiAccessUsageExampleLanguageChanged', // Property: value
  apiAccessCopyAccessTokenClicked = 'apiAccessCopyAccessTokenClicked', // Property: value
  apiAccessCopyRefreshTokenClicked = 'apiAccessCopyRefreshTokenClicked', // Property: value
  apiAccessCopyUsageExampleClicked = 'apiAccessCopyUsageExampleClicked', // Properties: value, language

  /* Swagger Section */
  swaggerButtonClicked = 'swaggerButtonClicked', // Property: className
  swaggerSelectClicked = 'swaggerSelectClicked', // Property: className
  swaggerLinkClicked = 'swaggerLinkClicked', // Property: href
  swaggerInputChanged = 'swaggerInputChanged', // Property: type
  swaggerSelectChanged = 'swaggerSelectChanged', // Property: className

  /* Cross-App Functionality */

  mapSearchLocation = 'mapSearchLocation',
  termsOfUseMapLinkClicked = 'termsOfUseMapLinkClicked',
  privacyPolicyMapLinkClicked = 'privacyPolicyMapLinkClicked',
  appUserOnline = 'appUserOnline',
  appUserOffline = 'appUserOffline',
  windowResize = 'windowResize', // Properties: width, height

  /* Map Tools Main Section */

  mapToolsGoToMyLocationClicked = 'mapToolsGoToMyLocationClicked',
  mapToolsToggleMapStyleClicked = 'mapToolsToggleMapStyleClicked',
  mapToolsZoomInClicked = 'mapToolsZoomInClicked',
  mapToolsZoomOutClicked = 'mapToolsZoomOutClicked',
}

enum GaTrackingMethod {
  PAGE_VIEW = 'PAGE_VIEW',
  EVENT = 'EVENT',
}

const GaCompatiblePropsMap: { [propkey: string]: GaTrackingMethod } = {};

export const init = async (userData?: UserData) => {
  try {
    ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_KEY, {
      testMode: process.env.REACT_APP_ANALYTICS_ENABLED !== 'true',
      gaOptions: {
        userId: userData && userData.id ? userData.id : undefined,
      },
    });
  } catch (err) {
    captureError(err);
  }
};

export const track = (event: TrackedEvent, properties?: { [propKey: string]: string | number }) => {
  let propsStr: string = '';
  if (properties && Object.keys(properties).length) {
    propsStr = Object.keys(properties).reduce((propsStr: string, propKey: string) => {
      const curGaTrackingMethod: GaTrackingMethod = GaCompatiblePropsMap[propKey];
      return (propsStr += !!curGaTrackingMethod ? ` - ${properties[propKey]}` : '');
    }, '');
  }

  try {
    ReactGA.event({
      category: 'User',
      action: `${event}${propsStr}`,
    });
  } catch (err) {
    captureError(err);
  }

  if (process.env.REACT_APP_ANALYTICS_ENABLED !== 'true') {
    console.log('TRACK', `${event}${propsStr}`);
  }
};
